export default "__VITE_ASSET__jHnVcFPB__"